import styled from "styled-components";

export const DepositLimitsHeaderButtonPCWrapper = styled.a.attrs({
  className: "circleIcon"
})`
  border-color: var(--desktop-header-icon-circle-color);
  height: var(--header-circle-icon-height);
  width: var(--header-circle-icon-width);

  .svg-wrapper .svg-icon {
    background-color: var(--desktop-header-icon-svg-color);
  }

  .mrg-theme & {
    border-color: var(--desktop-header-icon-circle-color);
    height: var(--header-circle-icon-height);
    width: var(--header-circle-icon-width);

    .svg-wrapper .svg-icon {
      background-color: var(--desktop-header-icon-svg-color);
    }
  }
`;
